// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify' // path to vuetify export
import Vuex from 'vuex'

import VueI18n from 'vue-i18n'
import messages from '@/lang/_langs'

import { supportedLocalesInclude } from '@/lang/_supported-locales'

Vue.use(VueI18n)
Vue.use(Vuex)
Vue.config.productionTip = false

function getStartingLocale() {
	const browserLocale = navigator.language.split('-')[0]

	if (supportedLocalesInclude(browserLocale)) {
		return browserLocale
	} else {
		return 'it'
	}
}

export const store = new Vuex.Store({
	state: {
		locale: getStartingLocale(),
		currentLocaleString: '',
		wPath: ''
	},

	mutations: {
		UPDATE_LOCALE(state, newLocale){
			state.locale = newLocale
		},

		UPDATE_CURRENT_LOCALE_STRING(state, newLocaleString){
			state.currentLocaleString = newLocaleString
		},

		UPDATE_WALKED_PATH(state, newWP){
			state.wPath = newWP
		}
	},

	actions: {
		updateLocale({ commit }, newLocale){
			commit('UPDATE_LOCALE', newLocale)
		},

		updateCurrentLocaleString({ commit }, newLocaleString){
			commit('UPDATE_CURRENT_LOCALE_STRING', newLocaleString)
		},
		
		updateWalkedPath({ commit }, newWP){
			commit('UPDATE_WALKED_PATH', newWP)
		}
	}
})

const i18n = new VueI18n({
	locale: store.state.locale,
	fallbackLocale: store.state.locale,
	messages
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	vuetify,
	router,
	i18n,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js